"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function CounselingMenu() {
  return <section id="menu" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          <div className="order-1">
            <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">カウンセリングメニュー</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">対面でも、オンラインでも<br />ひとりでも、ふたりでも</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">カウンセリングをどういう形で行うかはさまざまです。対面で行うことが多いですが、こちらまで来ることが難しい場合はオンラインで行うこともできます。</p>
              <p className="text-foreground leading-relaxed font-default">また、必ずしも一人でやるとも限りません。パートナーと二人で、あるいは家族で行うこともあります。</p>
              <p className="text-foreground leading-relaxed font-default">自分、自分たちに合わせたカウンセリングを一緒につくっていきましょう。</p>
            </div>
            <div className="pt-8">
              <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
                <Link to="https://yotsuya-sc-room.com/menu/">カウンセリングメニュー・料金を見る</Link>
              </Button>
            </div>
          </div>

          <div className="order-2">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/hourglass-menu.jpg" data-wvc-srcset="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/hourglass-menu.jpg-wvc-srcset" data-wvc-sizes="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/hourglass-menu.jpg-wvc-sizes" alt="窓際に置かれた砂時計、床面に細かいビーズ" className="w-full rounded-lg shadow-lg object-cover aspect-[4/3]" loading="lazy" decoding="async" />
          </div>

        </div>
      </div>
    </section>;
}